import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { TOKEN_KEY } from '../config';
import { api } from '../services/api';

const AuthContext = createContext(null);

function decodeJwt(token) {
  try {
    const base = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base));
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    return t ? decodeJwt(t) : null;
  });
  const [pronto, setPronto] = useState(false);

  useEffect(() => {
    if (!token) {
      setUser(null);
      setPronto(true);
      return;
    }
    let cancelado = false;
    api.get('/auth/me')
      .then(({ data }) => { if (!cancelado) setUser(data); })
      .catch(() => {
        if (!cancelado) {
          localStorage.removeItem(TOKEN_KEY);
          setToken(null);
          setUser(null);
        }
      })
      .finally(() => { if (!cancelado) setPronto(true); });
    return () => { cancelado = true; };
  }, [token]);

  const login = useCallback((novoToken) => {
    localStorage.setItem(TOKEN_KEY, novoToken);
    setToken(novoToken);
    setUser(decodeJwt(novoToken));
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  }, []);

  const temPermissao = useCallback((nome) => {
    if (!user) return false;
    if (user.tipo === 'cliente') return false;
    return Array.isArray(user.permissoes) && user.permissoes.includes(nome);
  }, [user]);

  return (
    <AuthContext.Provider value={{ token, user, pronto, login, logout, temPermissao }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
